<template>
  <div class="info-header">
    <div class="left">
      <img :src="userInfo.headImgUrl" class="avatar" />
      <div>
        <p class="nick">{{ userInfo.nickName }}</p>
        <p class="number" v-show="userInfo.memberType==1">卡券：{{userInfo.cardNumber}}张</p>
        <p class="number" v-show="userInfo.memberType==0">趣豆：{{userInfo.currentScore}}个</p>
      </div>
    </div>
    <div class="right" @click="changeRouter('exchange')">激活兑换码</div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      info: {
        pic: require("@/static/images/home/timg.jpg"),
      }, //个人信息
    };
  },
  mounted() {
    this.getMemberInfo();
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
  },
  computed: {
    ...mapState(["openIdKey", "userInfo"]),
  },
};
</script>

<style lang="less" scoped>
.info-header {
  height: 97px;
  background-color: #ffaa5e;
  padding-left: 39px;
  padding-right: 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
    color: #fff;
    .avatar {
      width: 70px;
      height: 70px;
      border-radius: 100%;
      margin-right: 24px;
    }
    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 70px;
      .nick {
        padding-top: 2px;
        font-size: 28px;
        padding-bottom: 4px;
      }
      .number {
        font-size: 24px;
      }
    }
  }
  .right {
    width: 175px;
    height: 48px;
    background-image: linear-gradient(90deg, #29b971 0%, #00cc66 100%),
      linear-gradient(#4161f0, #4161f0);
    background-blend-mode: normal, normal;
    border-radius: 22px;
    font-family: PingFang-SC-Regular;
    font-size: 26px;
    color: #fff;
    line-height: 48px;
    text-align: center;
  }
}
</style>
